import { render, staticRenderFns } from "./MagicLogin.vue?vue&type=template&id=3f2e230e"
import script from "./MagicLogin.vue?vue&type=script&lang=js"
export * from "./MagicLogin.vue?vue&type=script&lang=js"
import style0 from "./MagicLogin.vue?vue&type=style&index=0&id=3f2e230e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports